<template>
  <div>
    <div class="main-content">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header">
              <div class="card-title">Aprovações pendentes</div>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-md-12">
                  <table class="table table-hover">
                    <thead>
                      <tr>
                        <th scope="col">ID</th>
                        <th scope="col">Nome de Usuário</th>
                        <th scope="col">Veículo</th>
                        <th scope="col">Placa Veículo</th>
                        <th scope="col">Data da Reserva</th>
                        <th scope="col">Data de Retirada</th>
                        <th scope="col">Data de Devolução</th>
                        <th scope="col">Filial</th>
                        <th scope="col">Ações</th>
                      </tr>
                    </thead>
                    <tbody v-if="this.reservesCount > 0">
                      <tr v-for="(reserve, index) in filteredReserves" :key="reserve.id">
                        <td>{{ reserve.id }}</td>
                        <td>{{ reserve.user.name }}</td>
                        <td>{{ reserve.vehicles.description }}</td>
                        <td>{{ reserve.vehicles.board }}</td>
                        <td>{{ reserve.created_at }}</td>
                        <td>{{ reserve.retreat_date }}</td>
                        <td>{{ reserve.devolution_date }}</td>
                        <td>{{ reserve.branch.description }}</td>
                        <td>
                          <button type="button" class="btn btn-crud view" data-tooltip="tooltip" title="Visualizar"
                            @click="modalReserva(index)">
                            <i class="far fa-eye"></i>
                          </button>
                        </td>
                      </tr>
                    </tbody>
                    <tbody v-else>
                      <tr>
                        <td colspan="8" align="center">
                          Nenhuma reserva pendente de aprovação.
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <div class="pagination">
                    <button type="button" class="btn btn-primary mr-3" :disabled="currentPage === 1"
                      @click="currentPage -= 1">
                      Anterior
                    </button>
                    <span>Página {{ currentPage }} de {{ totalPages }}</span>
                    <button type="button" class="btn btn-primary ml-3" :disabled="currentPage === totalPages"
                      @click="currentPage += 1">
                      Próxima
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header">
              <div class="card-title">Histórico de moderação</div>
            </div>
            <div class="card-body">
              <base-crud crudName newText="Nova Reserva" :table="table" :columns="columns" :options="options"
                :endPoint="endPoint" :enableAdd="false" :enableEdit="false" :enableDelete="false" :enableView="false"
                :dataForm="dataForm" :customFilters="customFilters" @rDate="rDate" @reDate="reDate" @dDate="dDate"
                @mDate="mDate" :extra="extra" @view="view"></base-crud>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal Moderação -->
    <div class="modal fade" id="modalReservado" tabindex="-1" v-if="this.reservesCount > 0" role="dialog"
      aria-labelledby="modalReservadoTitle" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="modalReservadoTitle">
              Informações da pré-reserva
            </h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-md-5">
                <img class="car-pic" :src="reserves[index].vehicles.photo" alt />
              </div>
              <div class="col-md-7">
                <div class="car-info">
                  <div class="car-desc">
                    <div class="text">
                      {{ reserves[index].vehicles.description }}
                    </div>
                    <div class="data">{{ reserves[index].vehicles.board }}</div>
                    <div class="clearfix"></div>
                  </div>
                  <div class="car-desc">
                    <div class="text">Pré-reservado Para:</div>
                    <div class="data">{{ reserves[index].user.name }}</div>
                    <div class="clearfix"></div>
                  </div>
                  <div class="car-desc">
                    <div class="text">Retirada da Reserva:</div>
                    <div class="data">{{ reserves[index].created_at }}</div>
                    <div class="clearfix"></div>
                  </div>
                  <div class="car-desc">
                    <div class="text">Retirada Estimada:</div>
                    <div class="data">{{ reserves[index].retreat_date }}</div>
                    <div class="clearfix"></div>
                  </div>
                  <div class="car-desc">
                    <div class="text">Devolução Estimada:</div>
                    <div class="data">
                      {{ reserves[index].devolution_date }}
                    </div>
                    <div class="clearfix"></div>
                  </div>
                  <div class="car-desc">
                    <div class="text">Motivo da Reserva:</div>
                    <div class="data">{{ reserves[index].reason }}</div>
                    <div class="clearfix"></div>
                  </div>
                  <div class="car-desc">
                    <div class="text">Km Rodados:</div>
                    <div class="data km-total">
                      <the-mask disabled class="km-in-modal" :value="reserves[index].vehicles.current_km"
                        :mask="['####', '#.###', '##.###', '###.###']" />
                    </div>
                    <div class="clearfix"></div>
                  </div>
                  <div class="car-desc">
                    <div class="form-group">
                      <label for="observation">
                        <span class="required">*</span> Observação:
                      </label>
                      <textarea class="form-control" v-model="observation" rows="6"></textarea>
                    </div>
                  </div>
                  <div class="buttons">
                    <a @click="approve(reserves[index].id)" class="btn btn-alt float-left">Aprovar</a>
                    <a @click="reject(reserves[index].id)" class="btn btn-del float-right">Reprovar</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal Histórico -->
    <div class="modal fade" id="modalHistorico" tabindex="-1" role="dialog" aria-labelledby="modalHistoricoTitle"
      aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="modalHistoricoTitle">
              Informações da Reserva
            </h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-md-5">
                <img class="car-pic" :src="this.photo" alt />
              </div>
              <div class="col-md-7">
                <div class="car-info">
                  <div class="car-desc">
                    <div class="text">{{ this.vehicleDescription }}</div>
                    <div class="data">{{ this.vehicleBoard }}</div>
                    <div class="clearfix"></div>
                  </div>
                  <div class="car-desc">
                    <div class="text">Pré-reservado Para:</div>
                    <div class="data">{{ this.userReserve }}</div>
                    <div class="clearfix"></div>
                  </div>
                  <div class="car-desc">
                    <div class="text">Data da Reserva:</div>
                    <div class="data">{{ this.created_at }}</div>
                    <div class="clearfix"></div>
                  </div>
                  <div class="car-desc">
                    <div class="text">Retirada Estimada:</div>
                    <div class="data">{{ this.retreat_date }}</div>
                    <div class="clearfix"></div>
                  </div>
                  <div class="car-desc">
                    <div class="text">Devolução Estimada:</div>
                    <div class="data">{{ this.devolution_date }}</div>
                    <div class="clearfix"></div>
                  </div>
                  <div class="car-desc">
                    <div class="text">Km Rodados:</div>
                    <div class="data km-total">
                      <the-mask disabled class="km-in-modal" :value="this.vehicleKM"
                        :mask="['####', '#.###', '##.###', '###.###']" />
                    </div>
                    <div class="clearfix"></div>
                  </div>
                  <div class="car-desc">
                    <div class="text">Analisado em:</div>
                    <div class="data">{{ this.moderated_at }}</div>
                    <div class="clearfix"></div>
                  </div>
                  <div class="car-desc">
                    <div class="text">Analisado por:</div>
                    <div class="data">{{ this.moderated_by }}</div>
                    <div class="clearfix"></div>
                  </div>
                  <div class="car-desc">
                    <div class="text">Status:</div>
                    <div class="data">{{ this.status }}</div>
                    <div class="clearfix"></div>
                  </div>
                  <div class="car-desc">
                    <div class="form-group">
                      <label for="observation">
                        <span class="required">*</span> Observação:
                      </label>
                      <textarea class="form-control" v-model="this.observation" rows="6" disabled></textarea>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BaseCrud from "../Base/BaseCrud";

export default {
  data() {
    return {
      currentPage: 1,
      itemsPerPage: 15,
      totalPages: 1,
      customFilters: [
        {
          name: "retreat_date",
          type: "calendar",
          call: "rDate",
        },
        {
          name: "devolution_date",
          type: "calendar",
          call: "dDate",
        },
        {
          name: "created_at",
          type: "calendar",
          call: "reDate",
        },
        {
          name: "moderated_at",
          type: "calendar",
          call: "mDate",
        },
      ],

      retreat_date: "",
      devolution_date: "",
      moderated_at: "",
      /* Base Crud Histórico */

      table: "moderationTable",
      // pages: [],
      // url: '',
      columns: [
        "id",
        "user_id",
        "created_at",
        "retreat_date",
        "devolution_date",
        "moderated_at",
        "moderated_by",
        "status",
        "actions",
      ],
      tableData: [
        "id",
        "user_id",
        "created_at",
        "retreat_date",
        "devolution_date",
        "moderated_at",
        "moderated_by",
        "status",
      ],
      options: {
        filterByColumn: true,
        debounce: 1000,
        filterable: ["id", "user_id", "moderated_by", "status"],
        pagination: { chunk: 10, dropdown: false, nav: "scroll" },
        perPage: 10,
        perPageValues: [10, 25, 50, 100],
        headings: {
          id: "ID",
          user_id: "Nome do Usuário",
          created_at: "Data de Reserva",
          retreat_date: "Data de Retirada",
          devolution_date: "Data de Devolução",
          moderated_at: "Analisado em",
          moderated_by: "Analisado por",
          status: "Status",
          actions: "Ações",
        },
        texts: {
          filterBy: "Filtrar",
          defaultOption: "Selecione",
        },
        listColumns: {
          status: [
            {
              id: "Aprovado",
              text: "Aprovado",
            },
            {
              id: "Rejeitado",
              text: "Rejeitado",
            },
          ],
        },
        templates: {
          user_id: function (h, row, index) {
            return row.user ? row.user.name : "Sem Nome";
          },
          moderated_at: function (h, row, index) {
            return row.moderation ? row.moderation.created_at : "Sem Nome";
          },
          moderated_by: function (h, row, index) {
            return row.moderated_by ? row.moderated_by.name : "Sem Nome";
          },
          status: function (h, row, index) {
            return row.moderation
              ? row.moderation.moderated_status
              : "Sem Nome";
          },
        },
        requestFunction: function (data) {
          let requestData = {};

          let query = this.$parent.$parent.query(data.query);
          requestData.params = data;

          console.log(this.$parent.$parent.retreat_date);

          if (
            this.$parent.$parent.retreat_date != null &&
            this.$parent.$parent.retreat_date != ""
          ) {
            requestData.params.retreat_date = this.$parent.$parent.retreat_date;
          }

          if (
            this.$parent.$parent.devolution_date != null &&
            this.$parent.$parent.devolution_date != ""
          ) {
            requestData.params.devolution_date =
              this.$parent.$parent.devolution_date;
          }

          if (
            this.$parent.$parent.moderated_at != null &&
            this.$parent.$parent.moderated_at != ""
          ) {
            requestData.params.moderated_at = this.$parent.$parent.moderated_at;
          }

          requestData.params.query = "";
          requestData.params.with = [
            "user",
            "moderated_by",
            "vehicles",
            "moderation",
          ];

          return this.$http.get(this.url + "?" + query, requestData).catch(
            function (e) {
              this.dispatch("error", e);
            }.bind(this)
          );
        },
      },
      extra: [
        {
          id: 1,
          label: "",
          class: "fas fa-eye btn btn-crud view2",
          title: "Visualizar",
          name: "view",
          icon: "btn btn-crud view",
        },
      ],
      endPoint: "reserveVehicles/",
      dataForm: {},

      /* Fim Base Crud Histórico */

      photo: "",
      vehicleDescription: "",
      vehicleBoard: "",
      userReserve: "",
      created_at: "",
      retreat_date: "",
      devolution_date: "",
      vehicleKM: "",
      moderated_at: "",
      moderated_by: "",
      observation: "",
      status: "",

      reserves: [
        {
          vehicle: {
            description: "",
            photo: "",
          },
          user: {
            name: "",
            photo: "",
          },
          moderated_by: {
            name: "",
            photo: "",
          },
        },
      ],
      index: 0,
      errors: undefined,
      reservesCount: "",
    };
  },

  computed: {
    filteredReserves: function () {
      const startIndex = (this.currentPage - 1) * this.itemsPerPage;
      const endIndex = startIndex + this.itemsPerPage;

      let total = this.reserves.slice(startIndex, endIndex);
      return total;
    },
  },
  methods: {
    rDate(date) {
      console.log(date);
      this.retreat_date = date;
    },
    reDate(date) {
      console.log(date);
      this.created_at = date;
    },
    dDate(date) {
      console.log(date);
      this.devolution_date = date;
    },
    mDate(date) {
      console.log(date);
      this.moderation[created_at] = date;
    },
    query: function (query) {
      let columns = {
        id: "id",
        user_id: "user[name]",
        created_at: "created_at",
        retreat_date: "retreat_date",
        devolution_date: "devolution_date",
        moderated_at: "moderation[created_at]",
        vehicle_id: "vehicles[description]",
        vehicle_board: "vehicles[board]",
        status: "moderation[moderated_status]",
      };
      let filters = "moderated_at=1&";
      $.each(query, function (index, value) {
        filters += columns[index] + "=" + value + "&";
      });
      return filters;
    },

    getReserves: function (id) {
      const self = this;
      const api =
        self.$store.state.api +
        "reserveVehicles/?paginated=false&reserve_status=1&with[]=user&with[]=branch&with[]=vehicle_type_id&with[]=vehicles";

      self.$http
        .get(api)
        .then((response) => {

          self.reserves = response.data.data;
          console.log(response);
          console.log(self.reserves);
          self.reservesCount = response.data.count;
          self.totalPages = Math.ceil(self.reservesCount / self.itemsPerPage);

        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    modalReserva(index) {
      const self = this;
      const startIndex = (this.currentPage - 1) * this.itemsPerPage;
      self.index = startIndex + index;

      $("#modalReservado").modal({ show: true });
    },
    view: function (props, row, index) {
      const self = this;

      self.photo = props.row.vehicles.photo;
      self.vehicleDescription = props.row.vehicles.description;
      self.vehicleBoard = props.row.vehicles.board;
      self.userReserve = props.row.user.name;
      self.created_at = props.row.created_at;
      self.retreat_date = props.row.retreat_date;
      self.devolution_date = props.row.devolution_date;
      self.vehicleKM = props.row.vehicles.current_km;
      self.moderated_by = props.row.moderated_by.name;
      self.moderated_at = props.row.moderation.created_at;
      self.status = props.row.moderation.moderated_status;
      self.observation = props.row.moderation.observation;
      $("#modalHistorico").modal({ show: true });
    },

    approve(id) {
      const self = this;
      let api = self.$store.state.api + "reserveVehicles/" + id;
      let fd = new FormData();

      fd.append("_method", "PATCH");
      fd.append("op", "moderation");

      fd.append("reserve_status", "2");
      fd.append("observation", self.observation);
      fd.append("moderated_at", "1");
      fd.append("moderated_status", "Aprovado");
      fd.append("moderated_by", self.$store.state.user.id);

      self.$http
        .post(api, fd)
        .then((response) => {
          self.$message("Sucesso", `Pré-reserva aprovada`, "success");
          $("#modalReservado").modal("hide");

          $(function () {
            setTimeout(function () {
              self.getReserves();
            }, 1000);
            setTimeout(function () {
              location.reload();
            }, 1000);
          });
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    reject(id) {
      const self = this;

      let api = self.$store.state.api + "reserveVehicles/" + id;
      let fd = new FormData();

      fd.append("_method", "PATCH");
      fd.append("op", "moderation");

      fd.append("reserve_status", "3");
      fd.append("observation", self.observation);
      fd.append("moderated_at", "1");
      fd.append("moderated_status", "Rejeitado");
      fd.append("moderated_by", self.$store.state.user.id);

      self.$http
        .post(api, fd)
        .then((response) => {
          self.$message("Sucesso", `Pré-reserva rejeitada`, "success");
          $("#modalReservado").modal("hide");

          $(function () {
            setTimeout(function () {
              self.getReserves();
            }, 1000);
            setTimeout(function () {
              location.reload();
            }, 1000);
          });
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
  },
  mounted: function () {
    const self = this;
    self.getReserves();
  },
  components: {
    BaseCrud,
  },
};
</script>
<style scoped></style>

<style>
.uploading-image {
  display: flex;
}
</style>



// WEBPACK FOOTER //
// src/components/ReserveModeration/Moderation.vue